import { useEffect } from 'react';

export const isValidIdCase = (id: string): boolean => {
  const regex = /^[a-fA-F0-9-]{36}$/;
  return regex.test(id);
};

export const useValidationIdCase = (idCase: string,  callback: () => void, dependencies: any[]) => {
  useEffect(() => {
    if (idCase) {
      if (!isValidIdCase(idCase)) {
        console.error('Invalid idCase');
        return;
      }
      callback();
    } else {
      console.error('Missing idCase');
    }
  }, dependencies);
};